import dataReducer from "./reducers";

export default dataReducer;